import { jsxs as n, jsx as C } from "react/jsx-runtime";
import { getMainIconProps as o } from "./index.es2444.js";
function p(l) {
  const { outline: e, fill: t, size: i } = o(l);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: i,
      height: i,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M6.33992 12.1698C7.61282 13.3649 8.99952 14.5811 8.99952 14.5811C8.99952 14.5811 10.3863 13.3648 11.6592 12.1697C14.7703 12.5807 17 13.6927 17 15C17 16.6568 13.4183 18 9 18C4.58172 18 1 16.6568 1 15C1 13.6928 3.2293 12.5809 6.33992 12.1698Z",
            fill: t
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M8.75221 14.863C8.75221 14.863 8.75226 14.8631 8.99952 14.5811C9.24678 14.8631 9.24747 14.8625 9.24747 14.8625L8.99952 15.0799L8.75221 14.863Z",
            fill: e
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.1327 12.2387C12.7836 11.6222 13.388 11.0237 13.7354 10.6155C14.813 9.35062 15.375 8.00785 15.375 6.36306C15.375 2.84967 12.5264 0 9.01194 0H8.98806C5.47363 0 2.625 2.84967 2.625 6.36306C2.625 8.00782 3.18695 9.35052 4.26348 10.6153C4.61091 11.0236 5.21544 11.6223 5.86644 12.2388C3.00555 12.696 1 13.7601 1 15C1 16.6568 4.58172 18 9 18C13.4183 18 17 16.6568 17 15C17 13.76 14.9941 12.6958 12.1327 12.2387ZM3.375 6.36306C3.375 3.2638 5.88793 0.75 8.98806 0.75H9.01194C12.1121 0.75 14.625 3.2638 14.625 6.36306C14.625 7.80685 14.142 8.98171 13.1644 10.1293C12.6696 10.7107 11.5756 11.7466 10.5868 12.6521C10.0962 13.1014 9.63741 13.5134 9.30117 13.813C9.18458 13.9169 9.08276 14.0073 8.99952 14.081C8.91628 14.0073 8.81447 13.9169 8.69788 13.813C8.36164 13.5134 7.90281 13.1014 7.41221 12.6521C6.42342 11.7466 5.32944 10.7107 4.83463 10.1292C3.85785 8.98164 3.375 7.80688 3.375 6.36306ZM11.4292 12.8963C12.5736 13.0387 13.5853 13.2778 14.3935 13.5809C15.0682 13.8339 15.562 14.117 15.8738 14.3934C16.1864 14.6706 16.25 14.8772 16.25 15C16.25 15.1227 16.1864 15.3293 15.8738 15.6065C15.562 15.8829 15.0682 16.166 14.3935 16.419C13.0497 16.9229 11.143 17.25 9 17.25C6.85699 17.25 4.95026 16.9229 3.60649 16.419C2.93183 16.166 2.43796 15.8829 2.12623 15.6065C1.81363 15.3293 1.75 15.1227 1.75 15C1.75 14.8772 1.81363 14.6706 2.12623 14.3934C2.43796 14.117 2.93183 13.8339 3.60649 13.5809C4.41445 13.2779 5.42594 13.0389 6.56993 12.8964C6.68304 13.0009 6.79531 13.1042 6.90566 13.2052C7.39946 13.6575 7.86093 14.0718 8.19888 14.3729C8.36789 14.5236 8.5061 14.646 8.60211 14.7308L8.71308 14.8286L8.75221 14.863L8.99952 14.5811L9.24747 14.8625L9.28596 14.8286L9.39694 14.7308C9.49295 14.646 9.63115 14.5236 9.80016 14.3729C10.1381 14.0718 10.5996 13.6575 11.0934 13.2052C11.2038 13.1041 11.3161 13.0009 11.4292 12.8963Z",
            fill: e
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.99948 4.275C7.8269 4.275 6.875 5.22754 6.875 6.40052C6.875 7.57445 7.8268 8.52604 8.99948 8.52604C10.1733 8.52604 11.125 7.57435 11.125 6.40052C11.125 5.22764 10.1732 4.275 8.99948 4.275ZM6.125 6.40052C6.125 4.81373 7.41228 3.525 8.99948 3.525C10.5876 3.525 11.875 4.81363 11.875 6.40052C11.875 7.98856 10.5875 9.27604 8.99948 9.27604C7.41238 9.27604 6.125 7.98846 6.125 6.40052Z",
            fill: e
          }
        )
      ]
    }
  );
}
p.__tags = [];
export {
  p as GisIcon
};
//# sourceMappingURL=index.es294.js.map
